import client from "./client";

const getSettlements = () =>
  client.get("/subsidiary/dashboard/settlement/paginated?page=4&limit=100");

export default { getSettlements };
